<template>
  <div
    v-if="bomStore.availableMpnPropertyKeys.length > 0"
    class="d-flex flex-column gap-2 mt-2"
  >
    <div class="d-flex flex-shrink-0 align-items-center gap-2">
      <label
        class="guide-description mb-0"
        for="mpn-property-key"
        v-html="$t('MpnPropertyKeySelect.label')"
      />
      <select
        id="mpn-property-key"
        class="form-select form-select-sm w-auto"
        aria-describedby="mpn-property-key-help"
        :value="bomStore.mpnPropertyKey || ''"
        :disabled="bomStore.loading || bomStore.areJobsRunning || isModalActive"
        @change="setMpnPropertyKey($event)"
      >
        <option value="">
          {{ $t('MpnPropertyKeySelect.default') }}
        </option>
        <option
          v-for="key in bomStore.availableMpnPropertyKeys"
          :key="key"
          :value="key"
        >
          {{ key }}
        </option>
      </select>
    </div>
    <p
      id="mpn-property-key-help"
      class="guide-description mb-0"
      v-html="$t('MpnPropertyKeySelect.help')"
    />
  </div>
</template>

<script>
import messages from 'locales/MpnPropertyKeySelect';
import { useBomStore, useAssignStore } from 'store/bom';
import { useConfirmModal } from 'components/helper/useConfirmModal';

export default {
  name: 'MpnPropertyKeySelect',
  setup() {
    const bomStore = useBomStore();
    const assignStore = useAssignStore();
    const { askForConfirmation, isModalActive } = useConfirmModal();
    return {
      bomStore, assignStore, askForConfirmation, isModalActive,
    };
  },
  methods: {
    async setMpnPropertyKey(event) {
      const key = event.target.value || null;
      event.target.value = this.bomStore.mpnPropertyKey || '';
      if (key === this.bomStore.mpnPropertyKey) return;

      const confirmed = await this.askForConfirmation({
        title: this.$t('MpnPropertyKeySelect.confirmTitle'),
        message: this.$t('MpnPropertyKeySelect.confirmMessage'),
        confirmText: this.$t('MpnPropertyKeySelect.confirmAction'),
        confirmButtonClass: 'btn-outline-danger',
      });
      if (!confirmed) return;

      this.assignStore.softReset();
      await this.bomStore.setMpnPropertyKey(key);
    },
  },
  i18n: { messages },
};
</script>
